import { gsap, Power2 } from 'gsap'
import anime            from 'animejs'
import app_services     from './services'

export default class Rgpd
{
	constructor ()
	{
		this.url = app_rgpd.url ?? null
		this.services = app_rgpd.services ?? []
		this.popup = null
		this.button = null
	}
	
	init ()
	{
		this.addButton()
		this.addPopup()
		
		this.ls = localStorage.getItem('rgpd')
		
		if (this.ls)
		{
			JSON.parse(this.ls).forEach(service =>
			{
				this.acceptService(service)
			})
		}
		else
		{
			this.button.classList.add('open')
			this.popup.classList.add('visible')
		}
		
		const clickableServices = document.querySelectorAll('div[data-rgpd]')
		
		clickableServices.forEach(el =>
		{
			const service = this.services.filter(obj => obj.name === el.dataset.rgpd)[0]
			
			el.addEventListener('click', () =>
			{
				if (!service.allowed)
				{
					this.openPopup(true)
				}
			})
		})
		
		this.addScripts()
	}
	
	openPopup (openServices = false)
	{
		this.button.classList.add('open')
		this.popup.classList.add('visible')
		
		if (openServices)
		{
			this.openPopupServices()
		}
	}
	
	closePopup ()
	{
		this.closePopupServices()
		
		this.button.classList.remove('open')
		this.popup.classList.remove('visible')
	}
	
	openPopupServices ()
	{
		const services = this.popup.querySelector('.services')
		const buttons = this.popup.querySelector('.buttons')
		const realHeight = services.scrollHeight + 1
		const maxHeight = getComputedStyle(services).getPropertyValue('max-height')
		const height = realHeight > parseInt(maxHeight) ? parseInt(maxHeight) : realHeight
		
		if (realHeight > parseInt(maxHeight))
		{
			services.style.overflow = 'auto'
		}
		
		anime({
			targets: services,
			height: height,
			easing: 'easeOutQuart',
			duration: 500
		})
		
		this.popup.classList.add('services')
		/*const services = this.popup.querySelector('.services')
		 const buttons = this.popup.querySelector('.buttons')
		 
		 buttons.querySelectorAll('button[data-action="customize"], button[data-action="decline"]').forEach(_ =>
		 {
		 _.classList.add('hidden')
		 })
		 
		 buttons.querySelectorAll('button[data-action="back"], button[data-action="confirm"]').forEach(_ =>
		 {
		 _.classList.remove('hidden')
		 })
		 
		 gsap.to(services, {
		 height: 'auto',
		 duration: .5,
		 ease: Power2.easeOut,
		 onStart: () =>
		 {
		 services.classList.add('open')
		 }
		 })*/
	}
	
	closePopupServices ()
	{
		const services = this.popup.querySelector('.services')
		const buttons = this.popup.querySelector('.buttons')
		
		this.popup.classList.remove('services')
		
		anime({
			targets: services,
			height: 0,
			easing: 'easeOutQuart',
			duration: 500
		})
		/*const services = this.popup.querySelector('.services')
		 const buttons = this.popup.querySelector('.buttons')
		 
		 buttons.querySelectorAll('button[data-action="customize"], button[data-action="decline"]').forEach(_ =>
		 {
		 _.classList.remove('hidden')
		 })
		 
		 buttons.querySelectorAll('button[data-action="back"], button[data-action="confirm"]').forEach(_ =>
		 {
		 _.classList.add('hidden')
		 })
		 
		 gsap.to(services, {
		 height: 0,
		 duration: .5,
		 ease: Power2.easeOut,
		 onStart: () =>
		 {
		 services.classList.remove('open')
		 }
		 })*/
	}
	
	acceptService (service)
	{
		this.popup.querySelector('.services .toggle[data-service="' + service + '"]').classList.add('selected')
		this.services.filter(obj => obj.name === service)[0].allowed = true
	}
	
	declineService (service)
	{
		this.popup.querySelector('.services .toggle[data-service="' + service + '"]').classList.remove('selected')
		this.services.filter(obj => obj.name === service)[0].allowed = false
	}
	
	save ()
	{
		const servicesAllowed = this.services.filter(obj => obj.allowed)
		
		localStorage.setItem('rgpd', JSON.stringify(servicesAllowed.map(obj => obj.name)))
		
		this.addScripts()
		
		this.closePopup()
	}
	
	addScripts ()
	{
		this.services.forEach(obj =>
		{
			if (obj.allowed && !this.scriptExists(obj.name))
			{
				app_services[obj.name].allow(obj)
				
				const rgpd = document.querySelectorAll('div[data-rgpd="' + obj.name + '"]')
				
				rgpd.forEach(el =>
				{
					el.classList.add('allowed')
					
					const message = el.querySelector('.rgpd')
					
					if (message)
					{
						message.remove()
					}
				})
			}
			else if (!obj.allowed)
			{
				app_services[obj.name].decline(obj)
				
				const rgpd = document.querySelectorAll('div[data-rgpd="' + obj.name + '"]')
				const serviceName = app_services[obj.name].title
				
				rgpd.forEach(el =>
				{
					el.classList.remove('allowed')
					el.innerHTML = `<div class="rgpd">Pour afficher cet élément, cliquez ici et autorisez le service ${serviceName}</div>`
				})
			}
		})
	}
	
	scriptExists (service)
	{
		const scripts = Array.from(document.getElementsByTagName('script'))
		
		let result = false
		
		scripts.forEach(_ =>
		{
			if (_.dataset.service === service)
			{
				result = true
			}
		})
		
		return result
	}
	
	removeScript (service)
	{
		const scripts = Array.from(document.getElementsByTagName('script'))
		
		scripts.forEach(_ =>
		{
			if (_.dataset.service === service)
			{
				_.remove()
			}
		})
	}
	
	addButton ()
	{
		const div = document.createElement('div')
		
		div.id = 'rgpd-button'
		
		document.body.appendChild(div)
		
		this.button = div
		
		div.addEventListener('click', () =>
		{
			if (div.classList.contains('open'))
			{
				this.closePopup()
			}
			else
			{
				this.openPopup()
			}
		})
	}
	
	addPopup ()
	{
		const div = document.createElement('div')
		
		div.id = 'rgpd-popup'
		div.innerHTML = `
		<div class="inner">
			<div class="title">Cookies</div>
			<p>
				Ce site utilise des services tiers pouvant installer des cookies sur votre navigateur.
			</p>
			${this.url ? `
			<p>
				En savoir plus sur <a href="${this.url}">notre politique de confidentialité</a>.
			</p>
			` : ``}
		</div>
		
		<div class="services">
		${this.services.map(key => (
			`<div class="item">
				<div class="info">
					<div class="label">${app_services[key.name].title}</div>
					<div class="description">${app_services[key.name].description}</div>
				</div>
				
				<div class="toggle" data-service="${key.name}"></div>
			</div>`
		)).join('')}
		</div>
		
		<div class="buttons">
			<button data-action="accept">Tout accepter</button>
			<button data-action="customize">Personnaliser</button>
			<button class="hidden" data-action="confirm">Confirmer</button>
			<button data-action="decline">Tout refuser</button>
			<!--<button class="hidden" data-action="cancel">Annuler</button>-->
			<!--<button class="hidden" data-action="back">Retour</button>-->
		</div>
		`
		
		document.body.appendChild(div)
		
		this.popup = div
		
		// const services = div.querySelector('.services')
		const buttons = div.querySelector('.buttons')
		
		buttons.querySelectorAll('button').forEach(el =>
		{
			el.addEventListener('click', () =>
			{
				switch (el.dataset.action)
				{
					case 'accept':
						this.popup.querySelectorAll('.services .toggle').forEach(_ =>
						{
							_.classList.add('selected')
							
							this.acceptService(_.dataset.service)
						})
						
						this.save()
						
						break
					case 'customize':
						this.openPopupServices()
						
						break
					case 'decline':
						this.popup.querySelectorAll('.services .toggle').forEach(_ =>
						{
							_.classList.remove('selected')
							
							this.declineService(_.dataset.service)
						})
						
						this.save()
						
						break
					case 'back':
						this.closePopupServices()
						
						break
					case 'confirm':
						this.popup.querySelectorAll('.services .toggle').forEach(_ =>
						{
							const isSelected = _.classList.contains('selected')
							
							if (isSelected)
							{
								this.acceptService(_.dataset.service)
							}
							else
							{
								this.declineService(_.dataset.service)
							}
						})
						
						this.save()
						
						break
					case 'cancel':
						this.closePopup()
						
						break
				}
			})
		})
		
		div.querySelectorAll('.services .toggle').forEach(el =>
		{
			el.addEventListener('click', () =>
			{
				const isSelected = el.classList.contains('selected')
				
				if (!isSelected)
				{
					this.acceptService(el.dataset.service)
				}
				else
				{
					this.declineService(el.dataset.service)
				}
			})
		})
	}
}
